import { type Activity as ActivityType } from "@bentolabs/statistics-worker";
import { DateTime } from "luxon";

import { useActivityInfiniteQuery } from "shared/api/use-activity-infinite-query";

import { Row } from "./row";
import { RowGroup } from "./row-group";

function createGroups(activities: ActivityType[]) {
  const grouped = Object.groupBy(activities, (activity) => {
    const isoDate = DateTime.fromMillis(activity.timestamp).toISODate();
    if (!isoDate) return "unknown";
    return isoDate;
  });

  return Object.entries(grouped);
}

type Props = {
  className?: string;
};

export const Activity = (props: Props) => {
  const { className } = props;
  const activityQuery = useActivityInfiniteQuery();

  const activity = activityQuery.data?.pages.flatMap((p) => p) ?? [];

  const groups = createGroups(activity);

  if (!groups.length) return null;

  return (
    <section className={className}>
      <h2 className="mb-7 text-2xl">Activity</h2>

      <div className="flex flex-col gap-7">
        {groups.map((group) => {
          const [date, activities] = group;
          if (!activities) return;
          const humanDate = DateTime.fromISO(date).toRelativeCalendar() ?? "";
          return (
            <RowGroup key={date} title={humanDate}>
              {activities.map((activity) => {
                return <Row activity={activity} key={activity.tx} />;
              })}
            </RowGroup>
          );
        })}
      </div>
    </section>
  );
};
